// extracted by mini-css-extract-plugin
module.exports = {"header":"_b8","header__fixed":"_b9","header__sticky":"_ca","header__empty_block":"_cb"};